import styled from 'styled-components';

export const StyledMachineRobotPowerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .machine-robot-power__wrapper {
    display: flex;
    align-items: center;

    .machine-robot-power__icon {
      svg {
        width: 24px;
        height: 20px;
      }
    }

    .machine-robot-power__data {
      display: flex;
      width: 55px;

      .odometer-wrapper {
        font-family: ${(props): string => props.theme.fonts.captionBold};
        font-weight: ${(props): number => props.theme.fontWeights.captionBold};
        color: ${(props): string => props.theme.colors.black};
        font-size: 18px;
        height: 17px;
        line-height: 18px;
        word-break: break-word;
        white-space: normal;
      }

      .machine-robot-power__unit {
        font-family: ${(props): string => props.theme.fonts.captionBold};
        font-weight: ${(props): number => props.theme.fontWeights.captionBold};
        font-size: 18px;
        line-height: 18px;
        height: 18px;
        color: ${(props): string => props.theme.colors.black};
        margin: 0 4px;
      }
    }
  }

  .machine-robot-power__label {
    ${(props): string => props.theme.fontStyles.caption.news}
    color: ${(props): string => props.theme.colors.darkGrey};
    width: auto;
    word-break: break-word;
    white-space: normal;
  }
`;
